import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GraphQLComparision } from '../../../../enums/GraphQLComparision.enum';
import { ControlWidgetService, EveReportingControlWidgetWidget } from '../../../../services/ControlWidgetService.service';
import { GraphQLConnector, GraphQLFilter, IGraphQlService } from '../../../../services/GraphQl/IGraphQL.service';
import { EveReportingWidgetType } from '../../widget.component';

export interface DialogData {
  wheres: GraphQLFilter[];
  header: string;
  selectedEveUsers: any[]
}


@Component({
  selector: 'function-number-autocomplete-input-control-widget',
  templateUrl: 'function-number-autocomplete-input-control-widget.component.html',
  styleUrls: ['./function-number-autocomplete-input-control-widget.component.css']
})
export class FunctionNumberAutoCompleteInputControlWidgetComponent implements OnInit, OnDestroy {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  widgetTypes = EveReportingWidgetType;

  controlValue: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);


  selectedFunctionNumbers: any[];
  functionNumbers: any[];
  

  constructor(
    public controlWidgetService: ControlWidgetService,
    public graphQlService: IGraphQlService,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) {
   
  }

  onModelChange($event: any[]) {
    this.selectedFunctionNumbers = $event;

    this.controlValue.next(
      this.selectedFunctionNumbers.map(eu => eu.number.replace(/^0/i, '+44'))
    );

  }
  
    

  search(event) {
    
    this.graphQlService.getGraphQlResults({
      dataset: "functionNumbersPage",
      selects: [
        {
          field: "ownerTypeId",
          arguments: null
        },
        {
          field: "ownerId",
          arguments: null
        },
        {
          field: "name",
          arguments: null
        },
        {
          field: "number",
          arguments: null
        },
        {
          field: "avatarImageId",
          arguments: null
        }
      ],
      wheres: [
        { path: "name", comparison: GraphQLComparision.CONTAINS, value: event.query, connector: GraphQLConnector.OR } as GraphQLFilter,
        { path: "number", comparison: GraphQLComparision.CONTAINS, value: event.query, connector: GraphQLConnector.OR } as GraphQLFilter
      ],
      groupBys: [],
      orderBy: [{ path: "name", descending: false }, { path: "number", descending: false }],
      page: 0,
      pageSize: 10
    }).subscribe(response => this.functionNumbers = response.data.functionNumbersPage.items)
  } 
    

  ngOnInit(): void {

    if (this.widget != null && this.widget.controlWidgetId == null) this.widget.controlWidgetId = crypto.randomUUID();

    this.controlWidgetService.addControlWidget(this);


  }

  ngOnDestroy(): void {
    this.controlWidgetService.removeControlWidget(this);
  }

  
}



